import api from '~/services/api';

const inFlight = new Set();

// Dedupe por sessão (por aba): se storage estiver bloqueado, não quebra o app
function sessionHas(key) {
  try {
    return sessionStorage.getItem(key) === '1';
  } catch (e) {
    return false;
  }
}

function sessionSet(key) {
  try {
    sessionStorage.setItem(key, '1');
  } catch (e) {
    // ignora
  }
}

export function logPiiRevealOnce({ referId, referModel, fields, scope }) {
  if (!referId) return;

  const uniqueFields = Array.from(
    new Set((fields || []).filter(Boolean))
  ).sort();

  // chave de dedupe por sessão / pedido / tipo de card / campos
  const key = `@VIDDY:pii_reveal:${
    scope || 'default'
  }:${referId}:${uniqueFields.join(',')}`;

  if (sessionHas(key)) return;

  if (inFlight.has(key)) return;
  inFlight.add(key);

  api
    .post('/support/logs/pii-reveal', {
      refer_id: referId,
      refer_model: referModel, // ex.: "App/Cart"
      fields: uniqueFields, // ex.: ["cpf","email","telephone"]
      scope: scope || '',
      path: window.location.pathname,
    })
    .then(() => {
      // ✅ dedupe só se backend respondeu OK
      sessionSet(key);
    })
    .catch(() => {
      // falhou: não dedupa, permite tentar de novo
    })
    .finally(() => {
      inFlight.delete(key);
    });
}
